<template>
  <div class="instagram-analytics-public-header">
    <div class="custom-title" layout layout-align="start-center">
      キャンペーン分析
      <el-tooltip :content="campaign.account.name">
        <Icon
          class="mr-x1 ml-x2"
          :picture-url="campaign.account.pictureUrl"
          :name="campaign.account.name"
          :icon-type="campaign.targetSns"
        ></Icon>
      </el-tooltip>
      <div>{{ campaign.title }}</div>
    </div>
    <div class="mt-x1">
      期間: {{ formatDatetime(campaign.startDatetime) }} 〜 {{ formatDatetime(campaign.endDatetime) }}
    </div>
    <div v-if="isCampaignFinalCollection">
      <div class="mb-x2 mt-x1">
        <div class="message message-info">
          分析データの最終集計中です。<br />{{ collectCompletedAt }}
          ごろまでに最終的なデータが反映されます。応募件数により、反映が遅れる場合があります。
        </div>
      </div>
    </div>
    <div v-else-if="isCampaignCollectionCompleted">
      <div class="mb-x2">
        <div class="message message-info">分析データの最終集計が完了しました。</div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
// @ts-nocheck TODO: 既存の型エラーを解消したら外す
import moment from 'moment-timezone'
import { storeToRefs } from 'pinia'
import { computed, defineComponent } from 'vue'

import Icon from '@/client/components/_atoms/basic_icon'
import { CAMPAIGN_STATUS } from '@/client/constant'
import { useInstagramInstantwinAnalyticsPublicStore } from '@/client/features/instagram_instantwin_analytics_public/hooks/instagramInstantwinAnalyticsPublicStore'
import { formatDatetime } from '@/client/filters/filters'

export default defineComponent({
  components: { Icon },
  setup() {
    const store = useInstagramInstantwinAnalyticsPublicStore()
    const { campaign } = storeToRefs(store)

    const normalizedCampaign = computed(() => {
      const base = campaign.value ? { ...campaign.value } : { account: null }

      if (!base.account || !base.account.name) {
        base.account = {
          name: '削除されたアカウント',
          pictureUrl: require('@/client/assets/images/instagram_default_profile.png')
        }
      }

      return base
    })

    const isCampaignFinalCollection = computed(() => {
      return normalizedCampaign.value.status === CAMPAIGN_STATUS.DURING_FINAL_COLLECTION
    })

    const isCampaignCollectionCompleted = computed(() => {
      return normalizedCampaign.value.status === CAMPAIGN_STATUS.COLLECTION_COMPLETED
    })

    const collectCompletedAt = computed(() => {
      return moment(normalizedCampaign.value.endDatetime).add(1, 'hours').format('YYYY年MM月DD日 HH:mm')
    })

    return {
      campaign: normalizedCampaign,
      isCampaignFinalCollection,
      isCampaignCollectionCompleted,
      collectCompletedAt,
      formatDatetime
    }
  }
})
</script>
